/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import { useQuery, useSubscription } from '@apollo/react-components';
import store from '../../redux/store';
import Auth from '../../routes/auth';
import { GET_STRIPE_ID } from '../../graphql-query/graphql-query';

export const UserAuthenticationContext = React.createContext({
  user: null,
  session: null,
  isLoggedIn: false,
  isLoggingIn: true,
});

// eslint-disable-next-line react/prop-types
const UserAuthenticationProvider = ({ children }) => {
  const authToken = useSelector(state => state.auth);
  const [state, setState] = useState({
    user: null,
    session: null,
    isLoggedIn: false,
    isLoggingIn: true,
  });

  const [apiData, setApiData] = useState(null);

  useEffect(() => {
    window.process = {
      ...window.process,
    };
    console.log('We Received Token Data 2');
    console.log('');
    if (JSON.parse(localStorage.getItem('authToken'))) {
      console.log('We Received Token Data 4');
      console.log('User Token Exist !!');
      setState({
        session: JSON.parse(localStorage.getItem('authToken')),
        user: JSON.parse(localStorage.getItem('authToken'))?.id_token_claims,
        isLoggedIn: true,
        isLoggingIn: true,
      });
    }
  }, []);

  useEffect(() => {
    console.log('We Received Token Data.');
    console.log('Token Data : ', authToken.tokenData);
    if (authToken.tokenData && !state.session) {
      setState({
        session: authToken.tokenData,
        user: authToken.tokenData.id_token_claims,
        isLoggedIn: true,
        isLoggingIn: true,
      });
    } else if (JSON.parse(localStorage.getItem('authToken'))) {
      console.log('We Received Token Data 4');
      console.log('User Token Exist !!');
      const expirationTimeLeft =
        (JSON.parse(localStorage.getItem('authToken'))?.id_token_claims?.exp - new Date().getTime() / 1000) / 60;
      if (expirationTimeLeft > 0) {
        setState({
          session: JSON.parse(localStorage.getItem('authToken')),
          user: JSON.parse(localStorage.getItem('authToken'))?.id_token_claims,
          isLoggedIn: true,
          isLoggingIn: true,
        });
      } else {
        setState({
          user: null,
          session: null,
          isLoggedIn: false,
          isLoggingIn: true,
        });
      }
    } else {
      setState({
        user: null,
        session: null,
        isLoggedIn: false,
        isLoggingIn: true,
      });
    }
  }, [authToken, authToken.tokenData]);

  return (
    <>
      {!state.session ? (
        <Router basename={process.env.PUBLIC_URL}>
          <Route path="/" component={Auth} />
        </Router>
      ) : (
        <UserAuthenticationContext.Provider value={state}>{children}</UserAuthenticationContext.Provider>
      )}
    </>
  );
};

export default UserAuthenticationProvider;
